import { render, staticRenderFns } from "./EmailIcon.vue?vue&type=template&id=3106bd0a&scoped=true&"
import script from "./EmailIcon.vue?vue&type=script&lang=js&"
export * from "./EmailIcon.vue?vue&type=script&lang=js&"
import style0 from "./EmailIcon.vue?vue&type=style&index=0&id=3106bd0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3106bd0a",
  null
  
)

export default component.exports